import { useConfig } from './useConfig';

/**
 * Local site configuration schema
 */
export interface SiteConfigLocal {
    clientId?: string;
    template?: string;
    theme?: {
        primaryColor?: string;
        secondaryColor?: string;
        fontDisplay?: string;
    };
    content?: {
        siteName?: string;
        heroHeadline?: string;
        heroSubtitle?: string;
    };
    features?: {
        ticker?: boolean;
        confetti?: boolean;
        tokenGating?: boolean;
    };
}

// Import local site config
import localConfigData from '../../site.config.json';
const localConfig: SiteConfigLocal = localConfigData;



/**
 * Get the active template from environment or local config
 */
export function getActiveTemplate(): string {
    // Priority: env var > local config > default
    return (
        import.meta.env.VITE_ACTIVE_TEMPLATE ||
        localConfig?.template ||
        'degen'
    );
}

/**
 * Hook to access merged site configuration
 * Combines remote config (from API/DB) with local overrides
 */
export function useSiteConfig() {
    const { config: remoteConfig, isLoading, isError, error, refetch } = useConfig();

    // Merge configs: local overrides remote for theme/branding
    const mergedConfig = {
        ...remoteConfig,
        ...(localConfig && {
            theme: { ...remoteConfig?.theme, ...localConfig.theme },
            content: { ...remoteConfig?.content, ...localConfig.content },
            features: { ...remoteConfig?.features, ...localConfig.features },
        }),
    };

    return {
        config: mergedConfig,
        localConfig,
        activeTemplate: getActiveTemplate(),
        isLoading,
        isError,
        error,
        refetch,
    };
}
